import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id", "name"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["id", "name"]
const _hoisted_4 = ["name", "aria-describedby"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_infotext = _resolveComponent("infotext")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.gewerbeId) + ". Gewerbe-Art", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_zelle, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              id: _ctx.gewerbeArtMitId,
              name: _ctx.gewerbeArtMitId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeListe[_ctx.gewerbeId - 1].art) = $event)),
              class: "c-form-control-select",
              "data-fehlermeldung": "Bitte wählen Sie die Art des Gewerbes aus.",
              required: "",
              "aria-required": "true",
              "aria-label": "Art des Gewerbes",
              "data-cy": "gewerbeGewerbeArt"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GEWERBEARTEN, (gewerbeart) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: gewerbeart.art,
                  value: gewerbeart.art
                }, _toDisplayString(gewerbeart.beschreibung), 9, _hoisted_2))
              }), 128))
            ], 8, _hoisted_1), [
              [
                _vModelSelect,
                _ctx.piniaStore.state.gebaeudedaten.gewerbeListe[_ctx.gewerbeId - 1].art,
                void 0,
                {
                  lazy: true,
                  trim: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler[_ctx.gewerbeArtMitId],
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.piniaStore.state.gebaeudedaten.gewerbeListe[_ctx.gewerbeId - 1].art === _ctx.GEWERBEART_SONSTIGE)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, null, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, "Beschreibung " + _toDisplayString(_ctx.gewerbeId) + ". Gewerbe", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_zelle, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  id: _ctx.gewerbeBeschreibungMitId,
                  name: _ctx.gewerbeBeschreibungMitId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeListe[_ctx.gewerbeId - 1].beschreibung) = $event)),
                  class: "c-form-control__input",
                  placeholder: "Beschreibung des Gewerbes",
                  minlength: "3",
                  maxlength: "70",
                  "data-fehlermeldung": "Bitte beschreiben Sie die Art des sonstigen Gewerbes (3-70 Zeichen).",
                  required: "",
                  "aria-required": "true",
                  "aria-label": "Beschreibung des Gewerbes",
                  "data-cy": "gewerbeGewerbeArtSonstigesBeschreibung"
                }, null, 8, _hoisted_3), [
                  [
                    _vModelText,
                    _ctx.piniaStore.state.gebaeudedaten.gewerbeListe[_ctx.gewerbeId - 1].beschreibung,
                    void 0,
                    {
                      lazy: true,
                      trim: true
                    }
                  ]
                ]),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler[_ctx.gewerbeBeschreibungMitId]
                }, null, 8, ["fehler-text"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": true,
          "info-box-id": _ctx.gewerbeflaecheMitId
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.gewerbeId) + ". Anteil Gewerbefläche", 1),
            _cache[4] || (_cache[4] = _createTextVNode(" in % "))
          ]),
          _: 1,
          __: [4]
        }, 8, ["info-box-id"]),
        _createVNode(_component_zelle, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
              name: _ctx.gewerbeflaecheMitId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeListe[_ctx.gewerbeId - 1].flaeche) = $event)),
              class: "c-form-control__input",
              min: "1",
              max: "49",
              "data-fehlermeldung": "Überwiegend gewerblich genutzte Gebäude können wir nicht versichern.",
              "data-cy": "gewerbeGewerbeFlaeche",
              required: "",
              "aria-required": "true",
              "aria-label": "Anteil an Gewerbefläche",
              "aria-describedby": _ctx.gewerbeArtMitId
            }, null, 40, _hoisted_4), [
              [
                _vModelText,
                _ctx.piniaStore.state.gebaeudedaten.gewerbeListe[_ctx.gewerbeId - 1].flaeche,
                void 0,
                {
                  lazy: true,
                  trim: true,
                  number: true
                }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler[_ctx.gewerbeflaecheMitId]
            }, null, 8, ["fehler-text"]),
            _createVNode(_component_infotext, {
              role: "tooltip",
              id: _ctx.gewerbeArtMitId,
              name: _ctx.gewerbeflaecheMitId,
              text: "Anteil der gewerblich genutzten Fläche in Prozent von der Gesamtfläche des Gebäudes."
            }, null, 8, ["id", "name"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}